export const languageStringsPopups = {
  deletionWasSuccessful: "Az eltávolítás sikeres volt.",
  saveWasSuccessful: "Sikeresen elmentve",
  visualChanged: "A megjelenés sikeresen beállítva.",
  notificationAdded: "Az értesítés hozzáadásra került.",
  setButtonText: "Állítsa be a gomb szövegét.",
  missingHttp: 'Az URL-nek "http" vagy "https" előtaggal kell kezdődnie.',
  addNameAndText: "Adja hozzá az értesítés nevét és a szöveget.",
  textMustBeFilled: "Az értesítés szövegét ki kell tölteni.",
  connectionMissing:
    'Legalább egy elemet teljesítenie kell a "Csatlakozás" részben.',
  added: "Hozzáadva.",
  fillAllFields: "Töltse ki az összes mezőt",
  fillApiKey: "Adja meg az API kulcsot",
  webCreatedSuccessfully: "A weboldal sikeresen létrehozva.",
  notVerified: "Nincs ellenőrizve",
  changesSaved: "A módosítások sikeresen elmentve",
  changeSubscriptionDisabled:
    "Az előfizetési feltételek módosítása le van tiltva",
  subscriptionChangedTo: "Az előfizetés erre módosult: ",
  subscriptionCanceled: "Az előfizetés sikeresen törölve",
  nameIsEmpty: "A név nem lehet üres",
  cannotCreateNotification: "Nem sikerült létrehozni az értesítést.",
  fillApiAndPlaceId: "Adja meg az API kulcsot és a Place ID-t.",
  verificationFailed: "Az ellenőrzés sikertelen.",
  apiKeyVerificatedSuccess: "Az API kulcs sikeresen ellenőrizve.",
  fillApiAndBusinessUnitId: "Adja meg az API kulcsot és a Business Unit ID-t.",
  googleReviewsWasVerified: "A Google értékelések sikeresen ellenőrizve.",
};
